const getCurrentOffset = (offset = 0, itemsPerPage = 1, paginationIndex = 1, limit) => {
  if (paginationIndex <= 1) return Number(offset);
  const cumulativeOffset = Number(offset) + Number(itemsPerPage) * (Number(paginationIndex) - 1);
  return !!limit && cumulativeOffset >= limit ? offset : cumulativeOffset;
};

export default getCurrentOffset;
